import { render, staticRenderFns } from "./Gou.vue?vue&type=template&id=5ca3139c&scoped=true"
import script from "./Gou.vue?vue&type=script&lang=js"
export * from "./Gou.vue?vue&type=script&lang=js"
import style0 from "../../../../company/statistics/css/fullCompanyDetail.css?vue&type=style&index=0&id=5ca3139c&prod&scoped=true&lang=css&external"
import style1 from "../../../../company/statistics/css/commonCompany.css?vue&type=style&index=1&id=5ca3139c&prod&scoped=true&lang=css&external"
import style2 from "./Gou.vue?vue&type=style&index=2&id=5ca3139c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca3139c",
  null
  
)

export default component.exports